import moment from "moment";

function hasZ(raw: unknown): boolean {
  return typeof raw === "string" && raw.endsWith("Z");
}

export function normalizeUtc(raw?: string | Date | null): string | null {
  if (!raw) return null;
  if (raw instanceof Date)
    return isNaN(raw.getTime()) ? null : raw.toISOString();
  if (typeof raw !== "string") {
    const d = new Date(raw as any);
    return isNaN(d.getTime()) ? null : d.toISOString();
  }
  return raw;
}

export function formatLocal(
  raw?: string | Date | null,
  fmt = "hh:mm a"
): string {
  const val = normalizeUtc(raw);
  if (!val) return "";
  if (hasZ(val) || raw instanceof Date) return moment(val).format(fmt);
  const parsed = moment(val);
  return parsed.isValid() ? parsed.format(fmt) : val;
}

export function toLocalMoment(
  raw?: string | Date | null
): moment.Moment | null {
  const val = normalizeUtc(raw);
  if (!val) return null;
  const m = moment(val);
  return m.isValid() ? m : null;
}

export function toLocalDate(raw?: string | Date | null): Date | null {
  const val = normalizeUtc(raw);
  if (!val) return null;
  const d = new Date(val);
  return isNaN(d.getTime()) ? null : d;
}

const LEGACY_FORMATS = [
  "DD-MM-YYYY hh:mm a",
  "DD-MM-YYYY hh:mm A",
  "DD-MM-YYYY HH:mm",
  "YYYY-MM-DD hh:mm a",
  "YYYY-MM-DD hh:mm A",
  "YYYY-MM-DD HH:mm",
];

export function formatAppointmentDateTime(
  appointmentDateTiming?: string | null,
  appointmentDate?: string | null,
  appointmentTime?: string | null,
  fmt = "DD-MM-YYYY hh:mm A"
): string {
  const val = normalizeUtc(appointmentDateTiming);
  if (val) {
    if (hasZ(val)) return moment(val).format(fmt);
    const parsed = moment(val);
    return parsed.isValid() ? parsed.format(fmt) : val;
  }

  if (!appointmentDate && !appointmentTime) return "-";
  const raw = `${appointmentDate || ""} ${appointmentTime || ""}`.trim();
  const parsed = moment(raw, LEGACY_FORMATS, true);
  return parsed.isValid() ? parsed.format(fmt) : raw || "-";
}
